/* Group the existing about-page nodes; merchant text and links remain untouched. */
(() => {
  'use strict';
  if (window.ivonneAboutLayout) return;
  window.ivonneAboutLayout = true;
  function enhance(scope = document) {
    scope.querySelectorAll('.warm-about-content:not([data-about-layout])').forEach(content => {
      const source = content.children.length === 1 && content.firstElementChild.tagName === 'SECTION' ? content.firstElementChild : content;
      const nodes = [...source.childNodes];
      const intro = document.createElement('div');
      intro.className = 'warm-about-intro';
      const stories = document.createElement('div');
      stories.className = 'warm-about-stories';
      let current = intro;
      let faq;
      nodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2') {
          current = document.createElement('section');
          current.className = 'warm-about-story';
          stories.append(current);
        }
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'DIV' && node.querySelector('h3') && node.querySelector('h4')) {
          faq = node;
          faq.classList.add('warm-about-faq');
        } else {
          current.append(node);
        }
      });
      const layout = [intro, stories];
      if (faq) {
        const questions = [...faq.children].find(el => el.querySelector('h4'));
        if (questions) {
          const answers = [...questions.childNodes];
          questions.classList.add('warm-about-answers');
          let answer;
          answers.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H4') {
              answer = document.createElement('div');
              answer.className = 'warm-about-answer';
              questions.append(answer);
            }
            if (answer) answer.append(node);
          });
        }
        layout.push(faq);
      }
      source.replaceChildren(...layout);
      content.dataset.aboutLayout = 'true';
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
